<div class="timeline-steps-wrapper">
    <button type="button" class="timeline-arrow timeline-arrow-left"
        [class.disabled]="!canScrollLeft" (click)="scrollLeft()"
        aria-label="Ver passos anteriores">
        <img src="assets/images/icon-chevron-left.svg" width="16" height="16" alt=""
            class="timeline-arrow-icon" aria-hidden="true" />
    </button>

    <div #scrollContainer class="timeline-steps-scroll" (scroll)="onScroll()">
        <div class="timeline-steps-track">
            <div class="timeline-step"
                *ngFor="let step of timelineSteps; let last = last; let i = index">
                <div class="timeline-step-above">
                    <span class="timeline-step-role" *ngIf="showRoleName(i)">
                        {{ step.role_name }}
                    </span>
                    <span class="timeline-step-label">
                        {{ step.step_label }}
                    </span>
                </div>
                <div class="timeline-step-line-wrap">
                    <div class="timeline-step-line" [class.last]="last"></div>
                    <div class="timeline-step-indicator"
                        [class.complete]="isPastStep(i)"
                        [class.half]="isCurrentStep(i)"></div>
                </div>
                <div class="timeline-step-below"
                    *ngIf="!step.is_editing_step && (step.signed_by || step.approved_at)">
                    <span class="timeline-step-approved-by"
                        *ngIf="step.signed_by">
                        Aprovado por {{ step.signed_by }}
                    </span>
                    <span class="timeline-step-date" *ngIf="step.approved_at">
                        {{ formatDate(step.approved_at) }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <button type="button" class="timeline-arrow timeline-arrow-right"
        [class.disabled]="!canScrollRight" (click)="scrollRight()"
        aria-label="Ver próximos passos">
        <img src="assets/images/icon-right.svg" width="16" height="16" alt=""
            class="timeline-arrow-icon" aria-hidden="true" />
    </button>
</div>